import { useState } from "react"
import PropTypes from "prop-types"
import { map, isEmpty } from "lodash"
import { Tooltip, ClickAwayListener, List, ListItem, ListItemText, IconButton } from "@mui/material"
import { InfoOutlined } from "@mui/icons-material"

export default function InfoButton({ items }) {
  const [open, setOpen] = useState(false)

  if (isEmpty(items)) { return null }

  return <ClickAwayListener onClickAway={() => setOpen(false)}>
    <Tooltip
      placement="right-end"
      PopperProps={{
        disablePortal: true,
      }}
      classes={{
        tooltip: "info-tooltip",
        popper: "info-popper",
      }}
      onClose={() => setOpen(false)}
      open={open}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      title={<List>
        {map(items, ({ primary, secondary, className }, index) => (
          <ListItem key={`list-${index}`} className={className}>
            <ListItemText
              primary={primary}
              secondary={secondary}
            />
          </ListItem>
        ))}
      </List>}
    >
      <IconButton
        aria-label="info"
        className="info"
        onClick={() => setOpen(!open)}
        size="large"
      >
        <InfoOutlined />
      </IconButton>
    </Tooltip>
  </ClickAwayListener>
}

InfoButton.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    primary: PropTypes.string,
    secondary: PropTypes.string,
  })),
}
